import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../lib/seo';

function PaymentError() {
  useEffect(() => {
    setPageMeta({
      title: 'Payment Failed | Clouniq',
      description: 'We could not process your payment. Please try again.',
    });
  }, []);

  return (
    <section className="payment-error-section xp-payment-result-page">
      <div className="container">
        <div className="payment-result-card">
          <div className="result-icon error">!</div>
          <h2 className="result-title">Payment failed</h2>
          <p className="result-message">
            We could not complete the transaction. Check your payment details and try again.
          </p>

          <ul className="error-reasons">
            <li>Invalid or expired card data</li>
            <li>Insufficient account balance</li>
            <li>Temporary payment gateway issue</li>
            <li>Connection interruption during checkout</li>
          </ul>

          <div className="result-actions">
            <Link to="/payment" className="btn btn-primary btn-lg">Try again</Link>
            <Link to="/contact" className="btn btn-outline-primary btn-lg">Contact support</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PaymentError;



